import api from './axiosConfig';
import { handleApiError } from './errorHandler';

export const inventoryHistoryAPI = {
    getAll: async (
        page,
        pageSize,
        searchTerm,
        action,
        reason,
        userId,
        startDate,
        endDate,
        view,
        vendorName
    ) => {
        try {
            const { data } = await api.get('/api/inventory-history', {
                params: {
                    page,
                    pageSize,
                    searchTerm,
                    action,
                    reason,
                    userId,
                    startDate,
                    endDate,
                    view,
                    vendorName
                }
            });
            return data;
        } catch (error) {
            handleApiError(error, 'Get all inventory history error:');
        }
    }
};